import React, { useEffect } from 'react';
import loadable, { LoadableLibrary } from '@loadable/component';
import { useParams } from 'react-router-dom';
import { Container } from '../../../../../symphony';
import { SlLEContext } from '../../../global-constants';
import { SlActions } from '../../../services/ActionsService/sl-actions';
import { ActionType, RequestType } from '../../../global-interface';
import { ErrorCodes } from '../../../../../api/private/global.interface';
import { IMaterialStatus } from '../../../../../api/private/learn-engine-api/learn-engine-api.interface';

const CodeRepo: LoadableLibrary<unknown> = loadable.lib(
	() => import(/* webpackPrefetch: true */ '../../../../../leCodeRepo/public/SlLECodeRepo/SlLECodeRepo'),
);

export function CodeRepoMaterial(): JSX.Element {
	const { materialId, courseAlias } = useParams();
	const { actions$ } = Container.take(SlLEContext, SlActions);

	useEffect(() => {
		actions$.next({
			type: ActionType.OnCRMaterialMount,
			requestType: RequestType.Parallel,
			data: {
				alias: courseAlias,
				materialId: +materialId,
			},
		});
	}, []);

	const solveMaterialCallback = (statusChanges: IMaterialStatus[]): void => {
		actions$.next({
			type: ActionType.UpdateStatuses,
			requestType: RequestType.Parallel,
			data: {
				statusChanges,
			},
		});
	};

	const onSessionError = () => {
		actions$.next({
			type: ActionType.ExpiredSessionIdError,
			requestType: RequestType.Parallel,
		});
	};

	return (
		<CodeRepo>
			{({ SlLECodeRepo }) => (
				<SlLECodeRepo
					configs={{
						materialId: Number(materialId),
						solveMaterialCallback,
						courseAlias,
					}}
					errorHandler={{
						[ErrorCodes.ExpiredSession]: onSessionError,
					}}
				/>
			)}
		</CodeRepo>
	);
}
